// extracted by mini-css-extract-plugin
export var actionButton = "_ia-0";
export var fileInput = "_ia-2";
export var paperclip = "_ia-1";